/**
 * @flow
 * @relayHash 9aff42f7759aefe70744348fcd697b9c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type JobGenStatus = "FAILED" | "PENDING" | "SKIPPED" | "SUCCESS";
export type GenerateAllPendingJobsMutationVariables = {||};
export type GenerateAllPendingJobsMutationResponse = {|
  +generateAllPendingJobs: {|
    +result: {|
      +success: number,
      +failed: number,
      +skipped: number,
      +jobs: $ReadOnlyArray<{|
        +id: string,
        +jobNumber: string,
        +workflow: {|
          +id: string,
          +name: string,
        |},
        +order: ?{|
          +id: string,
          +orderNumber: string,
        |},
      |}>,
      +logs: $ReadOnlyArray<{|
        +id: string,
        +status: JobGenStatus,
        +errorMessage: ?string,
      |}>,
    |}
  |}
|};
export type GenerateAllPendingJobsMutation = {|
  variables: GenerateAllPendingJobsMutationVariables,
  response: GenerateAllPendingJobsMutationResponse,
|};
*/


/*
mutation GenerateAllPendingJobsMutation {
  generateAllPendingJobs {
    result {
      success
      failed
      skipped
      jobs {
        id
        jobNumber
        workflow {
          id
          name
        }
        order {
          id
          orderNumber
        }
      }
      logs {
        id
        status
        errorMessage
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "generateAllPendingJobs",
    "storageKey": null,
    "args": null,
    "concreteType": "GenerateAllPendingJobsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "result",
        "storageKey": null,
        "args": null,
        "concreteType": "GenerateJobsResult",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "success",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "failed",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "skipped",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobs",
            "storageKey": null,
            "args": null,
            "concreteType": "Job",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "jobNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workflow",
                "storageKey": null,
                "args": null,
                "concreteType": "Workflow",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderNumber",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "logs",
            "storageKey": null,
            "args": null,
            "concreteType": "JobGenerationLog",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "errorMessage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GenerateAllPendingJobsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GenerateAllPendingJobsMutation",
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "GenerateAllPendingJobsMutation",
    "id": null,
    "text": "mutation GenerateAllPendingJobsMutation {\n  generateAllPendingJobs {\n    result {\n      success\n      failed\n      skipped\n      jobs {\n        id\n        jobNumber\n        workflow {\n          id\n          name\n        }\n        order {\n          id\n          orderNumber\n        }\n      }\n      logs {\n        id\n        status\n        errorMessage\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ddb03fa9fb288893646bf25bcf8c37f4';
module.exports = node;
